// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1gfOA","content":"LoadingAlert_content__3spRr"};